__turbopack_context__.v({
  "body": "styles-module-scss-module__qt8Wuq__body",
  "clipboard-icon-container": "styles-module-scss-module__qt8Wuq__clipboard-icon-container",
  "friend-icon-container": "styles-module-scss-module__qt8Wuq__friend-icon-container",
  "header": "styles-module-scss-module__qt8Wuq__header",
  "idea-icon-container": "styles-module-scss-module__qt8Wuq__idea-icon-container",
  "salary-icon-container": "styles-module-scss-module__qt8Wuq__salary-icon-container",
  "search-icon-container": "styles-module-scss-module__qt8Wuq__search-icon-container",
  "stars-icon-container": "styles-module-scss-module__qt8Wuq__stars-icon-container",
});
